import { useState, useEffect } from 'react';
import ReactDOM from "react-dom";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default function EditorMultipleChoice(prop, { childToParent }) {
  const [Title, setTitle] = useState(prop.title);

  const inputHandler = (event, editor) => {
    //console.log(editor.getData());
    // Define your onSubmit function here
    // ...
    // for example, setData() here
    setTitle(editor.getData());

  };

  return (
    <div className="App">
      <CKEditor
        editor={ClassicEditor}
        config={{
          removePlugins: [
            "mergeTableCells"
          ],
          toolbar: ["undo", "redo", "bold", "italic", "blockQuote", "ckfinder", "imageTextAlternative", "imageUpload", "heading", "link", "numberedList", "align"]
        }}
        // data="<p>What are the solution(s) offered by your company?</p>"  
        data={Title}
        onReady={editor => {

          // console.log(Array.from( editor.ui.componentFactory.names() ));

          // console.log("What are the solution(s) offered by your company?", editor);
        }}
        // onChange={(event, editor) => { handleChange(e, setTitle)}}

        // onBlur={editor => {
        //  // console.log("Blur.", editor);
        // }}
        onChange={inputHandler}
        onBlur={editor => prop.childToParent(Title, prop.id)}
        onFocus={editor => {
          // console.log("Focus.", editor);
        }}
      />
    </div>

  );
}
